import styled from 'styled-components';

export const P = styled.p`
  font-weight: 500;
`;
